import { TermsAgreementType } from "@/apis/user/types";

export const TERMS_OF_SERVICE_URL = "https://invector.co/user-agreement";
export const PRIVACY_POLICY_URL = "https://invector.co/privacy-policy";

export const TERMS_AGREEMENT_ITEMS: Record<
  TermsAgreementType,
  { label: string; url: string }
> = {
  service: {
    label: "서비스 이용약관에 동의합니다.",
    url: TERMS_OF_SERVICE_URL,
  },
  privacy: {
    label: "개인정보 수집∙이용에 동의합니다.",
    url: PRIVACY_POLICY_URL,
  },
};
